import { getResolvedPath } from '../../../util/routing/entity-paths';

export const ACCOUNTING_TRIAL_BALANCE_BASE_PATH = getResolvedPath('/clearing/finance/accounting/trial-balance');
